
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,

            loading: false,
            page: 1,
            data_search: "",
            data: null,

            pre_po_main_number: "",
            pre_po_main_id: ""
        }
    }
    async componentDidMount() {
        this.Get();
    }
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            pre_po_main_id: ""
        }
        let result = await GET(tokens, "v1/TH/purchase-order/pre/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }
    Delete = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/purchase-order/pre/delete/" + this.state.pre_po_main_id, null);
        if (result && result.status) {
            success_url("/order/list-approve-order")
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="ระบบสั่งซื้อ" page3="บันทึกรออนุมัติสั่งซื้อ" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>บันทึกรออนุมัติสั่งซื้อ</b></h3>
                            <button className="btn btn-orange" onClick={() => { window.location.href = "/order/approve-order/detail" }}>
                                สร้างใหม่
                            </button>
                        </div>
                        <div className="w-100 card border-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <button className="btn btn-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1, data_search: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped" style={{ marginBottom: 200 }}>
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">เลขเอกสาร</th>
                                            <th className="text-center text-white">วันที่เอกสาร</th>
                                            <th className="text-center text-white">ทะเบียนรถ</th>
                                            <th className="text-center text-white">สถานะ</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.pre_po_main_number ? item.pre_po_main_number : "-"}</td>
                                                <td className="text-center">{item.date ? format_date(item.date, "dd/mm/yyyy") : "-"}</td>
                                                <td className="text-center">{item.remark ? item.remark : "-"}</td>
                                                <td className="text-center">{item.decision_status === 0 ? "รออนุมัติ" : "อนุมัติ"}</td>
                                                <td className="text-center">

                                                    <div className="w-100 d-flex justify-content-center">
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-cyan-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => { window.location.href = "/order/approve-order/detail?id=" + item.pre_po_main_id + "&type=readonly" }}>
                                                            <label className="pointer icon text-cyan p-2">{"\uf15b"}</label>
                                                        </div>
                                                        {item.decision_status === 0 && (
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                                onClick={() => { window.location.href = "/order/approve-order/detail?id=" + item.pre_po_main_id }}>
                                                                <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                            </div>
                                                        )}
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => { this.setState({ modal_delete: true, pre_po_main_id: item.pre_po_main_id, pre_po_main_number: item.pre_po_main_number }) }}>
                                                            <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบใบอนุมัติสั่งซื้อ</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบใบอนุมัติสั่งซื้อ “{this.state.pre_po_main_number}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.Delete() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
